import { useCallback, useEffect, useMemo, useState } from 'react';
import { Box, ButtonBase, Dialog, IconButton, makeStyles, Typography } from '@material-ui/core';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import * as Yup from 'yup';
import { AddIcon, CloseIcon } from '../../../../../components/Icon';
import { i18n } from '../../../../../language';
import AddTextInput from '../../AddTextInput';
import { baseCassConfirm } from '../baseCss';
import { bedStatusAPI } from '../../../../../apis';
import { classNames } from '../../../../../utils';
import { checkSubmitData } from '../../../../../utils/check';

const useStyles = makeStyles((theme) => ({
  addIcon: {
    width: '1.125rem',
    height: '1.125rem',
    color: '#538fff',
    marginRight: '0.813rem',
  },
  addRemarks: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
    color: '#538fff',
  },
  remarks: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
    color: '#2e4469',
  },
  buttonBase: {
    '&.Mui-disabled': {
      backgroundColor: '#c0c6cb',
    },
  },
  text: {
    fontSize: '1.25rem',
    color: '#2e4469',
    marginBottom: '2.2rem',
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
  },
}));

export default function ReturnDayCaseConfirmation({ open, closePop, returnDayCaseConfirmHandle }) {
  const classes = useStyles();
  const baseClasses = baseCassConfirm();
  const loginInfo = useSelector((state) => state.loginInfo);
  const [BsRemarkList, setBsRemarkList] = useState(null);
  const [formatData, setFormatData] = useState({
    remark: '',
  });
  const [errorMsg, setErrorMsg] = useState(null);

  const schema = {
    remark: Yup.string()
      .required(i18n.t('SETTING_IS_A_REQUIRED_FIELD', { value: i18n.t('BEDSTATUS_REMARKS') }))
      .max(255)
      .nullable(),
  };

  const confirmClick = async () => {
    try {
      await checkSubmitData(Yup.object().shape(schema), formatData);
      setErrorMsg(null);
      returnDayCaseConfirmHandle?.(formatData);
    } catch (errorMsg) {
      setErrorMsg(errorMsg);
    }
  };

  const focusCheck = async (name, value) => {
    try {
      await checkSubmitData(Yup.object().shape({ [name]: schema[name] }), { [name]: formatData[name] });

      setErrorMsg({ ...errorMsg, [name]: null });
    } catch (e) {
      setErrorMsg({ ...errorMsg, ...e });
    }
  };

  const remaksListApi = useCallback(async () => {
    try {
      const getBsRemarkList = await bedStatusAPI.getBsRemarkList({ wardId: loginInfo.wardId, isActive: 1 });
      setBsRemarkList(getBsRemarkList?.result?.data);
    } catch (error) {}
  }, []);

  const remarkList = useMemo(() => {
    if (BsRemarkList) {
      return _.map(BsRemarkList, (item) => {
        return item.remark;
      });
    }
    return [];
  }, [BsRemarkList]);

  const onChangeHandle = (type, key) => {
    return async (event) => {
      try {
        await checkSubmitData(Yup.object().shape({ [key]: schema[key] }), { [key]: event });
        setErrorMsg({ ...errorMsg, [key]: null });
      } catch (e) {
        setErrorMsg({ ...errorMsg, ...e });
      }
      setFormatData({ ...formatData, [key]: event ?? '' });
    };
  };
  useEffect(() => {
    (async () => {
      await remaksListApi();
    })();
  }, []);

  return (
    <Dialog open={open} maxWidth={false}>
      <div className={baseClasses.root}>
        <div className={baseClasses.header} style={{ padding: '2.187rem 0 1.562rem' }}>
          <Typography className={baseClasses.headerTitle}>
            {i18n.t('BEDSTATUS_RETURN_DAY_CASE_CONFIRMATION')}
          </Typography>
          <IconButton id="bed_cancelconfirmation_close_btn" className={baseClasses.closeIcon} onClick={closePop}>
            <CloseIcon />
          </IconButton>
        </div>
        <Box>
          <div className={classes.text}>{i18n.t('BEDSTATUS_RETURN_DAY_CASE_CONFIRMATION_TEXT_REMARKS')}</div>
          <AddTextInput
            btnId="bed_transferpop_remarks_btn"
            textId="bed_transferpop_remarks_input"
            popId="bed_transferpop_remarks_pop"
            allData={remarkList}
            title={
              <Typography className={classes.remarks} style={{ margin: '0rem 0 0.438rem 0', color: '#7d86a9' }}>
                {i18n.t('BEDSTATUS_REMARKS')}
              </Typography>
            }
            btnText={
              <Typography className={classes.addRemarks}>
                <AddIcon className={classes.addIcon} />
                {i18n.t('BEDSTATUS_ADD_REMARKS')}
              </Typography>
            }
            value={formatData.remark}
            onChange={onChangeHandle('select', 'remark')}
            style={{ marginTop: '.875rem' }}
            rows={3}
            errorMsg={errorMsg?.remark}
            // onBlur={focusCheck('remark')}
            onBlur={() => {
              (async () => {
                await focusCheck('remark');
              })();
            }}
          />
        </Box>
        <Box display="flex" justifyContent="center" style={{ margin: '3rem 0 2.375rem 0' }}>
          <ButtonBase
            id="bed_cancelconfirmation_cancel"
            className={baseClasses.cancelBtn}
            style={{ marginRight: '1.313rem' }}
            onClick={closePop}
          >
            {i18n.t('BEDSTATUS_CANCEL')}
          </ButtonBase>
          <ButtonBase
            id="bed_cancelconfirmation_confirm"
            className={classNames(baseClasses.configBtn, classes.buttonBase)}
            onClick={() => {
              (async () => {
                await confirmClick();
              })();
            }}
            // disabled={!remark ? true : false}
          >
            {i18n.t('BEDSTATUS_CONFIRM')}
          </ButtonBase>
        </Box>
      </div>
    </Dialog>
  );
}
